import {
  cloneElement
} from 'preact';
import { BaseComponent } from "../../base.component.js";

const itemHeight = 40;

/**
 * Accordion component provides accordion features to the badges. It needs to have as children AbAccordionItem components for best results.
 * Depending on the number of children the opening of an item behaves slightly different, for lower number of items the open item hovering a over the elements above.
 * @typedef {RenderableProps} _AbAccordion_Props
 * @property {number} selectedIndex - Currently selected index of the accordion (the opened element index)
 * @property {function()} onSelectedIndexChanged - Callback function getting called when the currently selected index has changed
*/
export default class AbAccordion extends BaseComponent {
  componentDidMount() {
    let { selectedIndex } = this.props;
    if (selectedIndex >= 0) {
      this.setState({
        selectedIndex
      })
    }
  }
  handleItemClick(index) {
    let selectedIndex = this.state.selectedIndex;
    let newSelectedIndex = index;
    if (selectedIndex === index)
      newSelectedIndex = -1;
    this.setState({
      selectedIndex: newSelectedIndex
    });
    this.props && this.props.onSelectedIndexChanged && this.props.onSelectedIndexChanged(newSelectedIndex);
  }
  render() {
    const children = (this.props.children || []).filter(c => !!c);
    const selectedIndex = this.state && this.state.selectedIndex;
    let openItemClass = "ab-accordion-item--open";
    children.length === 1 && (openItemClass += "-2");
    children.length === 2 && (openItemClass += "-1");
    const self = this;
    return (
      <div className={`${this.props.className}`} style={{
        height: (children && children.length * itemHeight) + "px"
      }}>
        <div className="ab-accordion-widget">
          {children && children.length > 0 && children.map((child, idx) => {
            const isOpen = selectedIndex === idx;
            const isHidden = false;
            const topPosition = (idx) * itemHeight;
            let newChild = cloneElement(child, {
              isOpen,
              isHidden,
              topPosition,
              openItemClass,
              height: itemHeight,
              onClick: () => self.handleItemClick(idx),
              zIndex: isOpen ? this.context.zIndex + 100 : this.context.zIndex + 99
            });
            return newChild;
          })}
        </div>
      </div >
    );
  }
}
